// extracted by mini-css-extract-plugin
module.exports = {"nameTd":"NeedingAttention_nameTd__WdgIY","ownerTd":"NeedingAttention_ownerTd__pCa_H","needs-attentions-table":"NeedingAttention_needs-attentions-table__ZZvl7"};